
export type Environment = 'dev' | 'stg' | 'pro'
export type Theme = 'light' | 'dark'
export type PrimitiveColor = 'primary' | 'primary-soft' | 'primary-dark' | 'black' | 'black-grey' | 'dark-grey' | 'soft-grey' | 'light-grey' | 'background-light' | 'background-dark' | 'white' | 'success' | 'error'
export type Primitives = Record<PrimitiveColor, string>
export type ThemeColor = 'background' | 'surface' | 'surface-2' | 'text' | 'icons' | 'border' | 'user-initials' | 'market' | 'menu'
export type Themes = Record<Theme, Record<ThemeColor, string>>


export const URL_BASE = process.env.REACT_APP_CONFIG_BASE_URL
export const SITE_ENV = process.env.REACT_APP_SITE_ENV as Environment

export type TopbarMenuItem = {
  id?: string
  type: 'event' | 'menu'
  text: string
  eventName?: string
  iconLeft?: string
  iconRight?: string
  tag?: string
  disabled?: boolean,
  active?: boolean,
  clickDisabled?: boolean,
  closeOnClick?: boolean,
  activeMode?: 'click' | 'hover',
  menuWidth?: number | string,
  menuMaxHeight?: number | string,
  menuScrollable?: boolean,
  menuFilterable?: boolean,
  menuCountText?: string,
  menuSearchPlaceholder?: string,
  options?: TopbarMenuItem[],
  data?: any
}

export type TopbarMenu = {
  text?: string
  version?: string,
  theme?: Theme,
  menuWidth?: number | string,
  menuMaxHeight?: number | string,
  menuScrollable?: boolean,
  menuFilterable?: boolean,
  menuCountText?: string,
  menuSearchPlaceholder?: string,
  activeMode?: 'click' | 'hover',
  options: TopbarMenuItem[]
} | null | undefined

export type Delegation = {
  uuid: string,
  organization_id?: number,
  parent_id?: number,
  name: string,
  delegation_identifier?: string,
  data?: string,
  delegation_type?: {
    id: number,
    name: string,
    has_profile: boolean
  }
}

export type DelegationsParent = {
  [key: string]: {
    delegations: Delegation[],
    customization: {
      name: string,
      logo: string
    },
    delegation_root: {
      uuid: string,
      name: string,
      delegation_identifier?: string
    }
  }
}

export type Delegations = {
  parents?: DelegationsParent
}